import axiosInstance from "@/utils/axios";
import API from "@/constant/API";

const AssetsService = {
  pendingDepositList: async (data) => {
    return await axiosInstance.post(API.DEPOSIT_PENDING_LIST, data);
  },
  cancelWithdrawOrder: async (data) => {
    return await axiosInstance.post(API.WITHDRAW_CANCEL, data);
  },
  getCurrencyList: async () => {
    return await axiosInstance.post(API.CURRENCY_LIST);
  },
  getCurrencyListJson: async () => {
    return await axiosInstance.get(API.CURRENCY_LIST_JSON);
  }
}
export default AssetsService;
